// Module
var code = "<span title=\"{{row['title-uniqueness-index']}}\"\n    am-tooltip=\"top center to bottom center\">{{row['display-uniqueness-index']}}</span>\n\n";
// Exports
module.exports = code;